var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IconKey"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17 9C17 8.46957 16.7893 7.96086 16.4142 7.58579C16.0391 7.21071 15.5304 7 15 7M15 15C16.262 14.9996 17.4918 14.6013 18.5144 13.8617C19.537 13.1222 20.3004 12.079 20.6959 10.8805C21.0915 9.68208 21.0991 8.38944 20.7176 7.18644C20.3361 5.98344 19.5851 4.93136 18.5712 4.17983C17.5573 3.42831 16.3323 3.01561 15.0704 3.00043C13.8084 2.98526 12.5739 3.36839 11.5422 4.09533C10.5106 4.82226 9.73442 5.85598 9.32415 7.04946C8.91388 8.24294 8.89038 9.5354 9.257 10.743L9 11L3.293 16.707C3.10545 16.8945 3.00006 17.1488 3 17.414V20C3 20.2652 3.10536 20.5196 3.29289 20.7071C3.48043 20.8946 3.73478 21 4 21H6C6.26522 21 6.51957 20.8946 6.70711 20.7071C6.89464 20.5196 7 20.2652 7 20C7 19.7348 7.10536 19.4804 7.29289 19.2929C7.48043 19.1054 7.73478 19 8 19C8.26522 19 8.51957 18.8946 8.70711 18.7071C8.89464 18.5196 9 18.2652 9 18C9 17.7348 9.10536 17.4804 9.29289 17.2929C9.48043 17.1054 9.73478 17 10 17H10.586C10.8512 16.9999 11.1055 16.8946 11.293 16.707L13 15L13.257 14.743C13.8222 14.914 14.4095 15.0006 15 15Z",
    stroke: "#002CFB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKey);
export default __webpack_public_path__ + "static/media/IconKey.4d9ce22e2ccc5846e759433813bd7439.svg";
export { ForwardRef as ReactComponent };